import axios, { setAuthorizationHeader } from '@/services/axios'
import { AxiosResponse } from 'axios'
import { SettingsSavePost, UserLoginPost } from './api-types'
import { User, UserToken } from './types'

const routeLogin = '/login'
const routeLogout = '/logout'
const routeGetUserInfo = '/getUserInfo'
const routeSendStat = '/stat'
const routeSettingsSave = '/settings/save'

export const login = async (data: UserLoginPost): Promise<UserToken> => {
  const result: AxiosResponse = await axios.post(routeLogin, data)
  return result.data.data
}

export const logout = async (): Promise<void> => {
  const result: AxiosResponse = await axios.post(routeLogout)
}

export const sendStat = async (): Promise<void> => {
  const result: AxiosResponse = await axios.get(routeSendStat)
}

export const getUserInfo = async (): Promise<User> => {
  setAuthorizationHeader(axios)
  const result: AxiosResponse = await axios.post(routeGetUserInfo)
  return result.data.data
}

export const settingsSave = async (data: SettingsSavePost): Promise<boolean> => {
  setAuthorizationHeader(axios)
  const result: AxiosResponse = await axios.post(routeSettingsSave, data)
  return result.data.data
}
